import { observable, action, makeObservable } from 'mobx'

export const TOAST_DURATION = 5000
// A warning stays up longer than a confirmation, so it isn't missed. See FE-1441.
export const WARNING_TOAST_DURATION = 10000

/**
 * Transient confirmation that the open document was quietly brought up to date.
 *
 * A singleton with an exported opener, mirroring ErrorDialog/model.js, so a
 * non-React caller (utils/DocumentSync.js) can raise it without any injection.
 */
class RemoteChangeToastModel {
  timeoutId = 0

  constructor() {
    makeObservable(this)
  }

  @observable show = false
  @observable messageKey = 'remoteChange.updated'
  // A warning tells the user their unsaved changes are gone, rather than
  // confirming an update.
  @observable warning = false

  @action open = ({
    messageKey = 'remoteChange.updated',
    warning = false,
  } = {}) => {
    this.show = true
    this.messageKey = messageKey
    this.warning = warning
    clearTimeout(this.timeoutId)
    this.timeoutId = setTimeout(
      this.close,
      warning ? WARNING_TOAST_DURATION : TOAST_DURATION
    )
  }

  @action close = () => {
    this.show = false
    clearTimeout(this.timeoutId)
    this.timeoutId = 0
  }
}

export const remoteChangeToastModel = new RemoteChangeToastModel()
export const showRemoteChangeToast = remoteChangeToastModel.open
